import { Pipe, PipeTransform } from '@angular/core';
import { EEntityType, ERelationType } from '@web/dtos';

@Pipe({
  name: 'toEntityLink',
  standalone: true,
})
export class ToEntityLinkPipe implements PipeTransform {
  transform(
    entity: EEntityType,
    relationType: ERelationType
  ): string | undefined {
    const findLink = (entity: string): string | undefined => {
      switch (entity) {
        case EEntityType.header:
          return '/cms/header';
        case EEntityType.banner:
          return '/cms/banner';
        case EEntityType.footerAddressArea:
        case EEntityType.footerLogoArea:
        case EEntityType.footerPaymentArea:
        case EEntityType.footerLinkArea:
          return '/cms/footer';
        case EEntityType.loginLogout:
          return '/cms/configuration/base';
        case EEntityType.generalArea:
          return '/cms/account/general-area';
        case EEntityType.salutation:
          return '/cms/configuration/base';
        case EEntityType.privateArea:
          return '/cms/configuration/base';
        case EEntityType.shoppingCart:
          return '/cms/general/shopping-cart';
        case EEntityType.corporateDesign:
          return '/cms/corporate-design';
        case EEntityType.appearance:
          return '/cms/appearance';
        case EEntityType.ticket:
          return '/cms/sortiment';
      }
      return undefined;
    };
    const link: string | undefined = findLink(entity);
    return link ? link + (relationType ? `#${relationType}` : '') : undefined;
  }
}
